"use client";
import clsx from "clsx";
import type { MouseEventHandler, ReactNode } from "react";

type Props = {
  as?: "button" | "span";
  id?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  children: ReactNode;
  className?: string;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  size?: "default" | "sm" | "icon";
  direction?: "up" | "right" | "down" | "left";
};
export const ButtonSecondaryAmis = ({
  as = "button",
  id,
  onClick,
  children,
  className,
  type = "button",
  disabled,
  size = "default",
  direction = "right",
}: Props) => {
  const rootClassName = clsx(
    "group/btn btn-secondary-amis border border-[#2E2825] rounded-lg text-tx-1 stroke-tx-1 relative overflow-hidden disabled:grayscale cursor-pointer disabled:cursor-not-allowed transition-shadow shadow-[0_0_0_0_rgba(185,87,51,0)] hover:shadow-[0_0_12px_0_rgba(185,87,51,0.72)] inline-flex items-center justify-center",
    {
      "h-12 px-6 text-base/5 font-semibold": size === "default",
      "h-10 px-6 text-sm font-semibold": size === "sm",
      "h-10 w-10": size === "icon",
    },
    className,
  );

  const content = (
    <span
      className={clsx(
        "flex justify-center items-center transition-transform group-hover/btn:drop-shadow-sm whitespace-nowrap",
        {
          "translate-x-0 group-hover/btn:translate-x-1": direction === "right",
          "translate-x-0 group-hover/btn:-translate-x-1": direction === "left",
          "translate-y-0 group-hover/btn:-translate-y-0.5": direction === "up",
          "translate-y-0 group-hover/btn:translate-y-0.5": direction === "down",
          "gap-2": size === "sm",
          "gap-4": size !== "sm",
        },
      )}
    >
      {children}
    </span>
  );

  if (as === "span") {
    return (
      <span id={id} className={rootClassName} aria-disabled={disabled}>
        {content}
      </span>
    );
  }

  return (
    <button id={id} type={type} className={rootClassName} onClick={onClick} disabled={disabled}>
      {content}
    </button>
  );
};
